'use client';
import { useSetAtom } from "jotai";
import { pageState } from '@/components/Atoms/PageAtom';
import { useEffect } from 'react';

export function SetCurrentPage({ currentPage }: { currentPage: string }): null {
    const setPage = useSetAtom(pageState);

    useEffect(() => {
        setPage(currentPage);
    }, []);

    return null;
}
